module.exports = __webpack_public_path__ + "img/266-141832.png";